<template>
  <transition name="pa-main-content-loading-fade">
    <div class="pa-content-loading-sheild" v-if="isLoading">
      <div class="content-field">
        <PuffLoadingImage class="waiting-loader" stroke="#BB9A66" />
      </div>
      <div class="overlay-field"></div>
    </div>
  </transition>
</template>

<script>
import PuffLoadingImage from '@/components/Pages/Office/ContentLoadingSheild/Images/puff.svg?inlineN'

export default {
  props : {
    isLoading : {
      default: false,
    }
  },

  components : {
    PuffLoadingImage
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@keyframes simpleFadeIn
{
  0%   {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.pa-main-content-loading-fade{
  &-enter-active{
    animation: simpleFadeIn .5s;
  }

  &-leave-active{
    animation: simpleFadeIn reverse .5s;
  }

  &-enter, &-leave-to{
    opacity: 0;
  }
}

.pa-content-loading-sheild{
  .content-field{
    position: absolute;
    top:0;
    left:0;
    z-index:501;
    width:100%;
    height: 100%;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin:0;
    padding:0;

    .waiting-loader{
      margin-top:-2rem;
    }
  }

  .overlay-field{
    position: absolute;
    top:0;
    left:0;
    margin:0;
    padding:0;
    z-index:500;
    width:100%;
    height:100%;
    background:linear-gradient(0deg, rgba($body-background-primary, .5), rgba($body-background-semi-light-darker, .4));
  }
}
</style>